import { Config } from '../types'
import { MoisesUpload } from './upload'
import { MoisesAuth } from './auth'
import { MoisesGraphQL } from './graphql'
import { MoisesTask } from './task'

export class Moises {
  config: Config

  session: any

  auth: MoisesAuth

  upload: MoisesUpload

  task: MoisesTask

  graphQL: MoisesGraphQL

  constructor(config: Config) {
    this.config = config
    this.session = {}

    this.upload = new MoisesUpload(this.config, this.session)
    this.auth = new MoisesAuth(this.config, this.session)
    this.task = new MoisesTask(this.config, this.session)
    this.graphQL = new MoisesGraphQL(this.config, this.session)
  }
}
